import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const DotItem = styled.div<{ $filled: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme, $filled }) =>
    $filled ? theme.colors.green6 : theme.colors.black4};
  transition: background-color 0.3s ease;
`;
